import React, {Component} from 'react'
import {Button, Col, Modal, Popconfirm, Row} from 'antd'
import {get} from 'lodash'
import BudgetLineForm from './BudgetLineForm'

class BudgetLineModal extends Component {
  render() {
    const {
      visibleBudget,
      updatingBudget,
      onCancelBudget,
      onAddBudget,
      onEditBudget,
      modalType,
      budgetFormRef,
      removeBudget,
      removingBudget,
      budget,
    } = this.props
    return (
      <Modal
        visible={visibleBudget}
        title={modalType === 'new' ? 'Add Budget' : 'Edit Budget'}
        onCancel={onCancelBudget}
        destroyOnClose={true}
        confirmLoading={updatingBudget}
        footer={
          <Row>
            <Col span={24} style={{textAlign: 'right'}}>
              {modalType === 'edit' && (
                <Popconfirm
                  title="Are you sure remove this line?"
                  onConfirm={() => removeBudget(budget.key || budget._id)}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    type="danger"
                    loading={removingBudget}
                    style={{marginLeft: 8}}>
                    Remove
                  </Button>
                </Popconfirm>
              )}
              <Button
                loading={updatingBudget}
                type="primary"
                onClick={modalType === 'new' ? onAddBudget : onEditBudget}>
                {modalType === 'new' ? 'Create' : 'Update'}
              </Button>
            </Col>
          </Row>
        }
        width={'95%'}>
        <BudgetLineForm ref={budgetFormRef} {...this.props} />
      </Modal>
    )
  }
}

BudgetLineModal.propTypes = {}
BudgetLineModal.defaultProps = {}

export default BudgetLineModal
